module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/E7vRun/tc-custom/9781446354339.jpg?1705038284266",
      "alt": "This image is the cover for the book Sewn Toy Tales, Melly & Me: Fun Fabulous Design"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sewn Toy Tales, Melly & Me: Fun Fabulous Design\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Melly & Me present a fun and fabulous collection of personality-packed designs that will have readers sewing adorable toys in no time! Each of the brightly colored characters is a joy to sew for all abilities, making them the perfect gift for children or adults, or a trendy home accessory. Projects combine simple sewing techniques with funky fabrics, embellishments and color palettes to add zing and excitement to readers' sewn toy creations. Easy to follow step by step instructions and quirky photography make this book a delightful gift as well as an irresistible addition to sewing collections.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Melanie Hurlston\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Melly & Me is a design label founded in 2006 by sisters Melanie Hurlston and Rosalie Quinlan. Specializing in bags and soft toys, the Melly & Me look is all about mix-and-match fabrics and modern colors. Rosalie recently launched her first range with well-known fabric company Lecien and both sisters attend all the major fabric design shows, including Quilt Market.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    David and Charles\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0